$(document).ready(function () {
  $.ajaxSetup({
    headers: {
      'X-CSRF-Token': $('meta[name="_token"]').attr('content')
    }
  });

  $('.load-ajax-modal').click(function () {
    $('.load-ajax-modal').off("click");
    let target = '#common-modal';
    if ($(this).data('target') !== undefined) {
      target = $(this).data('target');
    }
    $(target+' div.modal-body').html("");
    $(target).off();
    if ($(this).data('reload')) {
      $(target).on('hidden.bs.modal', function () {
        window.location.reload();
      })
    }
    let $query = '';
    if ($(this).data('query') !== undefined) {
      $query = $(this).data('query');
    }
    $.ajax({
      type: 'GET',
      url: $(this).data('path') + $query,

      success: function (result) {
        $(target+' div.modal-body').html(result);
      },
      error: function (xhr, status, error) {
        console.log("error", xhr, status, error);
      }
    });
  });
  $(document).on('show.bs.modal', '.modal', function (event) {
    if ($(".modal-backdrop").length > 1) {
      $(".modal-backdrop").not(':first').remove();
    }
    var zIndex = 1040 + (10 * $('.modal:visible').length);
    setTimeout(function () {
      $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
    }, 0);
  });

  if($.fn.dataTable){
    $.fn.dataTable.ext.errMode = function (settings, tn, msg) {
      if (settings && settings.jqXHR && settings.jqXHR.status == 401) {
        location.href = "/login"; // redirect to login
        return;
      }
      // show error on another error except 401
      console.error(msg)
    };
  }

  $(document).on('hidden.bs.modal', '.modal', function () {
    $('.modal:visible').length && $(document.body).addClass('modal-open');
  });

  delay = function (fn, ms) {
    let timer = 0
    return function (...args) {
      clearTimeout(timer)
      timer = setTimeout(fn.bind(this, ...args), ms || 0)
    }
  }
})
